import { jsx as _jsx } from "react/jsx-runtime";
import { DataTableColumnHeader } from "../DataTableColumnHeader";
/**
 * Helper function to create a column header with automatic onAddFilter extraction from context
 * This reduces code duplication across column definitions
 */ export function createColumnHeader(title) {
    const HeaderComponent = ({ column, ...context })=>/*#__PURE__*/ _jsx(DataTableColumnHeader, {
            column: column,
            title: title,
            onAddFilter: "onAddFilter" in context ? context.onAddFilter : undefined,
            onUpdateFilter: "onUpdateFilter" in context ? context.onUpdateFilter : undefined
        });
    HeaderComponent.displayName = `ColumnHeader_${title.replace(/\s+/g, "")}`;
    return HeaderComponent;
}

//# sourceMappingURL=column-header.js.map